var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ui-button",class:{
    'ui-button--disabled': _vm.disabled,
  }},[(_vm.loadingLeft)?_c('div',{staticClass:"ui-button--loading-left"},[_c('simple-loading')],1):(!_vm.loadingLeft && _vm.hasIcon)?_c('div',{staticClass:"ui-button__icon"},[_vm._t("icon")],2):_vm._e(),_vm._t("default"),(_vm.loadingRight)?_c('div',{staticClass:"ui-button--loading-right"},[_c('simple-loading')],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }